<template>
<div class="login-form">
    <div class="form border ">
        <router-link class="back-btn" :to="{name:'login'}">{{$lang('TEXT_LOGIN')}}</router-link>
        <b-form @submit="onSubmit">
            <div class="form-group">
                <b-form-radio-group v-model="forgotForm.type" plain name="plain-inline">
                    <!-- <b-form-radio value="email">{{$lang('電郵驗證')}}</b-form-radio> -->
                    <b-form-radio value="mobile">{{$lang('手機驗證')}}</b-form-radio>
                </b-form-radio-group>
            </div>
            <b-form-group class="user_name">
                <template slot="label">
                    <label></label>
                </template>
                <b-form-input v-model="forgotForm.username" type="text" name="username" :placeholder="$lang('用戶名')" :class="errors.has('username') && 'is-invalid' " v-validate="'required'"></b-form-input>
                <b-form-invalid-feedback :state="errors.has('username')">
                    {{errors.first('username')}}
                </b-form-invalid-feedback>
            </b-form-group>
            <div v-show="forgotForm.type === 'email'">
                <b-form-group class="email">
                    <template slot="label">
                        <label></label>
                    </template>
                    <b-form-input v-model="forgotForm.email" type="email" key="email" name="email" :class="errors.has('email') && 'is-invalid' " :placeholder="$lang('FIELD_EMAIL')" v-validate="{'required':status,'email':status}"></b-form-input>
                    <b-form-invalid-feedback :state="errors.has('email')">
                        {{errors.first('email')}}
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>

            <div v-show="forgotForm.type === 'mobile'">
                <b-form-group class="phone">
                    <template slot="label">
                        <label></label>
                    </template>
                    <b-form-input v-model="forgotForm.mobile" type="text" key="mobile" name="mobile" :class="errors.has('mobile') && 'is-invalid' " :placeholder="$lang('FIELD_PHONE')" v-validate="{'required':!status,'mobile':!status}"></b-form-input>
                    <b-form-invalid-feedback :state="errors.has('mobile')">
                        {{errors.first('mobile')}}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group class="verification authentication">
                    <template slot="label">
                        <label></label>
                    </template>
                    <b-form-input v-model="forgotForm.code" type="text" key="code" @change="checkCode" :state="codeState" name="verificationCode" :class="errors.has('verificationCode') && 'is-invalid' " :placeholder="$lang('FILED_CAPTCHA')" v-validate="{'required':!status}"></b-form-input>
                    <b-btn variant="info" @click="getCode" :disabled="disabled">
                        <span  class="tip" v-if="!sendMsgDisabled && !reGet">{{$lang('發送驗證碼')}}</span>
                        <span  class="tip" v-if="!sendMsgDisabled && reGet">{{$lang('重新獲取')}}</span>
                        <span  class="tip" v-if="sendMsgDisabled">{{rTime+$lang('秒後重新獲取')}}</span>
                    </b-btn>
                    <b-form-invalid-feedback :state="errors.has('verificationCode')">
                        {{errors.first('verificationCode')}}
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
            <b-button type="submit" class="login" variant="primary">{{$lang('TITLE_FIND_PASSWORD')}}</b-button>
        </b-form>
        <h4 v-html="$lang('TEXT_IF_NOT_EMAIL_CHANGE_PWD')"></h4>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from 'vuex'
import LaddaBtn from '@/components/ladda/Ladda'
export default {
    components: {
        LaddaBtn
    },
    data() {
        return {
            forgotForm: {
                username: "",
                email: "",
                mobile: "",
                code: "",
                type: 'mobile',
            },
            scene: 'change',
            loginLoading: false,
            codeState: null,
            reGet: false, // 重新获取
            rTime: 60, // 发送验证码倒计时
            sendMsgDisabled: false, // 发送验证码按钮状态
            disabled: false,
            tel: "",
            code: ""
        }
    },
    computed: {
        ...mapGetters('user', {
            captcha: 'captcha',
            captcha_url: 'captcha_url',
            sid: 'sid',
        }),
        status() {
            return this.forgotForm.type === 'email'
        }
    },
    watch: {

        'forgotForm.type': {
            handler(n) {
                this.codeState = null;
                this.forgotForm.email = '';
                this.forgotForm.mobile = '';
                this.forgotForm.code = '';
                this.$validator.reset();
            }
        }
    },
    methods: {
        ...mapActions('user', ['forgetPassword']),
        onSubmit(evt) {
            evt.preventDefault()
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loginLoading = true;
                    this.forgetPassword(this.forgotForm)
                        .then((resp) => {
                            this.loginLoading = false;
                            if (this.status) {
                                this.$router.push({
                                    name: 'change_password_email'
                                })
                            } else {
                                this.$router.push({
                                    name: 'change_password',
                                    params: {
                                        hash: resp.data.hash
                                    }
                                })
                            }
                        }).catch((err) => {
                            err.data.errors.forEach(item => {
                                let str = item.path.replace("[", "").replace("]", "")
                                this.errors.add({
                                    field: str,
                                    msg: item.message
                                })
                                console.log(this.errors)
                            })
                        })
                } else {
                    return false
                }
            })
        },
        checkCode() {
            let params = {
                mobile: this.forgotForm.mobile,
                code: this.forgotForm.code,
                scene: this.scene
            }
            this.$apis.checkCode(params).then(() => {
                this.codeState = true
            }).catch((err) => {
                this.errors.add({
                    field: "verificationCode",
                    msg: this.$lang(err.code)
                })
            })
        },
        sendCode(params) {
            return this.$apis.sendCode(params)
        },
        getCode() {
            this.$validator.validate('mobile').then((valid) => {
                if (valid) {
                    let that = this;
                    that.sendMsgDisabled = true;
                    let rTime = that.rTime;
                    that.disabled = true;
                    let params = {
                        mobile: this.forgotForm.mobile,
                        scene: this.scene,
                    }
                    this.sendCode(params);
                    //倒计时
                    let interval = setInterval(() => {
                        if (--that.rTime <= 0) {
                            that.rTime = rTime;
                            that.sendMsgDisabled = false;
                            that.disabled = false;
                            that.reGet = true; // 重新获取按钮
                            clearInterval(interval);
                        }
                    }, 1000);
                }
            })
        }
    },
}
</script>
